export default __webpack_public_path__ + "static/media/05AW1MAR66.cf12527d.jpg";